import type { components } from '../../types/api/generated';
import { ErrorType } from '@components/ErrorBoundary';
import { ffhClient } from '@lib/api/ffh-client';
import { authHeader } from '@lib/api/auth-header';

const TEAM_NOT_FOUND = 404;
const SERVICE_UNAVAILABLE = 502;
const INTERNAL_SERVER_ERROR = 500;

export type LiveRankData = NonNullable<
  components['schemas']['LiveRankResponse']['data']
>;

export type LiveRankError = { status: number; message: string };

type FetchLiveRankInfoOptions = {
  teamId: string;
  gameweek: number;
  accessToken: string;
};

const fetchLiveRankInfo = async ({
  teamId,
  gameweek,
  accessToken
}: FetchLiveRankInfoOptions): Promise<LiveRankData | LiveRankError | false> => {
  if (!teamId) {
    return false;
  }

  try {
    const { data, response } = await ffhClient().GET('/live/rank', {
      params: { query: { teamId: Number(teamId), gameweek } },
      headers: authHeader(accessToken)
    });

    if (response.status === TEAM_NOT_FOUND) {
      return {
        status: TEAM_NOT_FOUND,
        message: ErrorType.liveRankUserNotFoundError
      };
    }

    if (response.status === SERVICE_UNAVAILABLE) {
      return { status: SERVICE_UNAVAILABLE, message: ErrorType.fplFetchError };
    }

    if (!data) {
      return { status: response.status, message: ErrorType.isLiverankError };
    }

    return data.data;
  } catch (error) {
    console.error('[live-rank] unexpected fetch error', error);
    return {
      status: INTERNAL_SERVER_ERROR,
      message: ErrorType.isLiverankError
    };
  }
};

export default fetchLiveRankInfo;
